function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Forbidden Icon");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-icons-/-no",
  transform: "translate(-2.000000, -2.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M19.0710678,4.92893218 C20.9464316,6.80429597 22,9.3478351 22,12 C22,14.6521649 20.9464316,17.195704 19.0710678,19.0710678 C15.1658249,22.9763107 8.83417511,22.9763107 4.92893218,19.0710678 C1.02368926,15.1658249 1.02368925,8.83417511 4.92893218,4.92893218 C8.83417509,1.02368926 15.1658249,1.02368926 19.0710678,4.92893218 Z M16.9060207,5.67983461 C13.7675898,3.23730486 9.22788292,3.45840857 6.34314574,6.34314574 C3.45840855,9.22788293 3.23730485,13.7675898 5.67983461,16.9060207 L16.9060207,5.67983461 Z M18.3207866,7.09477762 L7.09538566,18.3202251 C8.49094752,19.4032549 10.2147107,20 12,20 C14.1217319,20 16.1565632,19.1571453 17.6568542,17.6568542 C20.5413468,14.7723617 20.7626576,10.2331801 18.3207866,7.09477762 Z"
})));

var SvgForbidden = function SvgForbidden(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgForbidden, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/forbidden.e01127fc.svg";
export { ForwardRef as ReactComponent };